<template>
  <div ref="SearchvillaContainer">
    <div v-show="showOnly" class="searchVilla villa-search" :style="getLayering" :class="{ 'page-region': region === 'region', 'section-nav': section === 'nav', 'page-exquisite': region === 'exquisite', 'page-exquisite-location': location==='hero', 'sticky': (isSticky && !isFooterinView), 'space': (region === 'homepage' && !isNav) }">
      <div v-if="!reducedSearch" class="searchVillaInner">
        <div v-if="!reducedSearch" class="searchVillaInnerGroup" :class="{'noRegion' : isGreece}">
          <MultipleDestinations v-if="!isGreece" :postion-top="destinationsTop" />
          <TTTDatePickerInput v-if="!reducedSearch"
                              :key="getSVKey"
                              picker-position="absolute"
                              :within-modal="false"
                              :instanceName="instanceName"
                              :no-border="true"
                              @visible="pickerVisibleChanged"
          />
          <GuestsDropdown v-if="!reducedSearch" />
          <!-- <BedroomsDropdown v-if="!reducedSearch" /> -->

          <div>
            <button class="villa-search__submit btn-primary-dark-lrg" type="button" @click="search($event)">
              {{ textFindVillas }}
            </button>
          </div>
        </div>
      </div>
      <button v-if="reducedSearch && !mobileViewOpen" class="searchVilla-toggle btn-primary-dark-lrg" type="button" @click="mobileToggle()">
        {{ textFindVillas }}
      </button>
    </div>
    <div v-if="isSticky && !isFooterinView" class="searchVilla-sticky-placeholder" />
    <div v-if="mobileViewOpen" class="searchVillaMobile villa-search" :class="{ 'open': mobileViewOpen }">
      <div class="searchVillaMobileHeader">
        <h1>Find a villa</h1>
        <span class="icon close lazyload" alt="Close" @click.prevent.stop="close" />
      </div>
      <div v-if="!reducedSearch || mobileViewOpen" class="searchVillaInner">
        <div class="searchVillaInnerGroup first" :class="{'noRegion' : isGreece}">
          <h3 v-if="!isGreece">
            Location
          </h3>
          <MultipleDestinations v-if="!isGreece" :postion-top="destinationsTop" />

          <h3>Add Dates</h3>
          <TTTDatePickerInput :key="getSVKey"
                              picker-position="absolute"
                              :within-modal="true"
                              :instanceName="instanceName"
                              :no-border="true"
                              @visible="pickerVisibleChanged"
          />

          <h3>Guests</h3>
          <GuestsDropdown />

          <!-- <BedroomsDropdown v-if="!reducedSearch" /> -->
        </div>
      </div>
      <div class="searchVillaMobileControls">
        <button class="villa-search__submit btn-primary-dark-lrg" type="button" @click="search($event)">
          {{ textFindVillas }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { _ } from 'vue-underscore';
import Bus from '../events/bus';
import responsive from '../mixins/responsive';
import routerLink from '../mixins/routerLink';
import closeTab from '../mixins/closeTab';
import uuid from '../mixins/uuid';
import trackingHelper from '../mixins/trackingHelper';
import TTTDatePickerInput from './TTTDatePicker/TTTDatePickerInput.vue';
import MultipleDestinations from './searchvilla/MultipleDestinations.vue';
import GuestsDropdown from './searchvilla/GuestsDropdown.vue';
// import BedroomsDropdown from './searchvilla/BedroomsDropdown.vue';

export default {
  components: {
    TTTDatePickerInput,
    MultipleDestinations,
    GuestsDropdown,
    // BedroomsDropdown,
  },
  mixins: [routerLink, closeTab, uuid, trackingHelper, responsive],
  props: {
    instanceName: { type: String, default: 'home' },
    textArrival: { type: String, required: true },
    textDeparture: { type: String, required: true },
    textFindVillas: { type: String, required: true },
    region: { type: String },
    location: { type: String },
    section: { type: String },
    showonly: { type: String },
    te: { type: Boolean },
    destinationsTop: { type: String, default: '72px' },
    trackingCategory: { type: String, required: false, default: 'topnav' }, // this is for GTM click tracking (either set to 'topnav' or 'hero')
  },
  data() {
    return {
      svkey: Math.random(),
      pickerOpen: false,
      mobileViewOpen: false,
    };
  },
  computed: {
    reducedSearch() {
      return this.isMobile;
    },
    getLayering() {
      return {
        zIndex: this.pickerOpen ? '3000' : '101',
      };
    },
    isResultsPage() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].templateId == 5 : false;
    },
    isRegionsPage() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].templateId == 24 : false;
    },
    isNav() {
      return this.section === 'nav';
    },
    isHomePage() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].templateId == 3 : false;
    },
    isHomeRegion() {
      return this.region == 'homepage';
    },
    isGreekIslandsRegion() {
      return this.region == 'greekislands';
    },
    isExquisiteDesktop() {
      return this.region === 'exquisite' && this.showonlyDesktop;
    },
    isExquisiteMobile() {
      return this.region === 'exquisite' && this.showonlyMobile;
    },
    showonlyDesktop() {
      return this.$mq === 'desktop' && this.showonly === 'desktop';
    },
    showonlyTablet() {
      return this.$mq === 'tablet' && this.showonly === 'tablet';
    },
    showonlyMobile() {
      return this.$mq === 'mobile' && this.showonly === 'mobile';
    },
    showOnlyTabletDesktop() {
      return this.showonly === 'tabletdesktop' && (this.$mq === 'tablet' || this.$mq === 'desktop');
    },
    showOnly() {
      return this.showOnlyTabletDesktop || this.showonlyMobile || this.showonlyDesktop || this.showonlyTablet || this.isExquisiteDesktop || this.isExquisiteMobile || this.isHomeRegion || this.isGreekIslandsRegion || this.isNav;
    },
    getSVKey() {
      return this.svkey;
    },
    dates: {
      get() {
        return this.$store.getters['filterbar/getDates'];
      },
      set(val) {
        this.$store.commit('filterbar/setDates', val);
      },
    },
    sticky: {
      get() {
        return this.$store.getters['searchvilla/getSticky'];
      },
      set(val) {
        this.$store.commit('searchvilla/setSticky', val);
      },
    },
    isSticky() {
      return this.sticky === true;
    },
    getDestinations() {
      return this.$store.getters['results/getDestinations'];
    },
    getSubDestinations() {
      return this.$store.getters['results/getSubDestinations'];
    },
    isGreece() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].parentPageId == 1087 : false;
    },
    isFooterinView() {
      return this.$store.getters['filterbar/getFooterInView'];
    },
    REGION_IDS() {
      return this.$store.getters['results/getRegionIDs'];
    }, 
  },
  mounted() {
    this.svkey = this.newUuidKey();
    window.addEventListener('resize', this.handleResize, { passive: true });
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.calculateSticky();
    setTimeout(() => this.calculateSticky(), 5000);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    pickerVisibleChanged(val) {
      // hack to toggle z-index
      if (val) {
        this.pickerOpen = val;
      } else {
        // delay to not be under content while animating out
        setTimeout(() => this.pickerOpen = val, 300);
      }
    },
    search(ev) {
      ev.preventDefault();
      ev.stopPropagation();
      const selectedPeople = this.$store.getters['results/getPeople'];
      const selectedRooms = this.$store.getters['results/getBedrooms'];
      const destinationsIDs = this.getDestinations.map((des) => des.id);
      const destinationsNames = this.getDestinations.map((des) => des.name);
      const subDestinationsIDs = this.getSubDestinations;
      
      // Hack for paxos & Antipaxos
      if (destinationsIDs.length > 0 && destinationsIDs[0] === this.REGION_IDS.PAXOS) {  
        destinationsIDs.push(this.REGION_IDS.ANTIPAXOS);
      }

      const redirectTo = {
        url: this.$store.getters['pages/getPageURLById'](16),
        params: {
          ...destinationsIDs.length > 0 && { des: destinationsIDs.toString() },
          ...this.isGreece && subDestinationsIDs.length > 0 && { subdes: subDestinationsIDs.toString() },
          ...this.dates && this.dates.start && { from: moment(this.dates.start).format('DD MMM YYYY') },
          ...this.dates && this.dates.end && { to: moment(this.dates.end).format('DD MMM YYYY') },
          ...selectedPeople != '' && { people: selectedPeople },
          ...selectedRooms != '' && { rooms: selectedRooms },
        },
      };

      // track every search click (for GTM tracking) - see trackingHelper mixin
      this.trackSearchClick(this.trackingCategory, {
        ...redirectTo.params, destinations: destinationsIDs, desNames: destinationsNames, people: selectedPeople, rooms: selectedRooms,
      });

      // Store
      this.$store.commit('results/setThinkExquisite', this.te);
      this.$router.push({ path: redirectTo.url, query: redirectTo.params });
      this.isResultsPage ? Bus.$emit('filterProperties', 'SEARCH VILLA BAR') : null;

      this.closeTab();
    },
    mobileToggle() {
      this.mobileViewOpen = !this.mobileViewOpen;
      this.hideBodyScroll(this.mobileViewOpen);
    },
    close() {
      this.mobileViewOpen = false;
      this.hideBodyScroll(false);
    },
    hideBodyScroll(hide) {
      const body = document.body;
      if (hide) {
        body.style.height = '100vh';
        body.style.overflowY = 'hidden';
      } else {
        body.style.height = '';
        body.style.overflowY = '';
      }
    },
    calculateSticky() {
      if (this.$refs.SearchvillaContainer && !this.isNav) {
        const elementTop = this.$refs.SearchvillaContainer.getBoundingClientRect().top;
        const actualBottom = elementTop + 70;
        // console.log('actualBottom: ' + actualBottom);
        if (actualBottom < 0) {
          if (!this.sticky) this.sticky = true;
        } else {
          if (this.sticky) this.sticky = false;
        }
      }
    },
    handleResize: _.throttle(function () {
      this.calculateSticky();
    }, 200),
    handleScroll: _.throttle(function () {
      this.calculateSticky();
    }, 200),
  },
};
</script>

<style lang="scss">

@import '../assets/styles/settings/config.scss';

  .searchVilla-sticky-placeholder {
    display: block;
    visibility: hidden;
    height: 72px;
    margin: 24px;
  }
  .searchVilla {
    position: relative;
    width: 100%;
    height: 72px;
    margin: 0 auto 0 auto;
    display: flex;
    background-color: transparent;
    border-radius: 5px;
    justify-content: center;
    overflow: visible;

    &.space {
      width: auto;
      // margin: 24px;
    }

    &.sticky {
      position: fixed;
      bottom: -72px;
      left: 0;
      right: 0;
      transition: transform .4s ease-in-out;
      transform: translateY(-72px);

      &.space {
        margin: 0;
      }
    }

    &.page-region {
      display: inline-flex;
      min-width: auto;
      margin-top: 0;
    }

    &.section-nav {
      background-color: $offwhite !important;
    }

    &.page-exquisite {
      margin: 30px auto;
    }

    .searchVillaInner {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      width: 100%;
      height: 100%;
      overflow: visible;
      background-color: $stoneWhite;

      > div {
        flex: 1;

        &:first-child {
          margin-top: 0;
        }

        margin-top: 5px;

        &:first-child {
          margin-top: 0;
        }
      }

      .searchVillaInnerGroup {
        display: flex;
        justify-content: center;

        > div {
          flex: 1;
          border: 1px solid $stoneLight;
          border-left: 0;
        }

        > div:first-child {
          border-left: 1px solid $stoneLight;
        }

        > div:last-child {
          border-style: none;
        }
      }
    }

    .villa-search__select {
      margin: 0;

      select {
        &.destination {
          min-width: 100% !important;
        }

        width: 100%;
      }
    }

    .main-search-holder {
      min-width: 272px;
    }

    .villa-search__submit {
      min-width: 180px;
      @media (max-width: 950px) {
        font-size: 15px;
      }
    }
  }

  .slidesearch-enter-active,
  .slidesearch-leave-active {
    transition: all .1s ease-out;
  }

  .slidesearch-enter,
  .slidesearch-leave-to {
    transform: translateY(-72px);
    opacity: 0;
  }

  .sticky .slidesearch-enter,
  sticky .slidesearch-leave-to {
    transform: translateY(72px);
    opacity: 0;
  }

  @media (max-width: 768px) {
    .searchVilla .searchVillaInner .searchVillaInnerGroup > div:last-child {
      margin: 0;
    }
  }

  @media (min-width: 768px) {

    .searchVilla {
      //max-width: 335px;
      background-color: transparent;

      &.section-nav {
        max-width: none;
        .searchVillaInner {
          flex-direction: column;
          flex-wrap: nowrap;
          > div {
            margin-top: 0;
          }
        }
      }

      &.page-exquisite {
        display: block;
        max-width: 1000px;
      }
      &.page-exquisite-location {
        display: none;
      }
      .villa-search__select {
        &:last-child {
          margin: 0;
        }
        select {
          width: 100%;
        }
      }
    }
  }

  @media (min-width: 1200px) {
    .searchVilla {
      max-width: none;
      &.section-nav {
        max-width: none;
        .searchVillaInner {
          flex-direction: row;
          flex-wrap: nowrap;
        }
      }
    }
  }

  @media (min-width: 1025px) {
    // Fixes blur effect and dimensions on firefox
    body.exquisite {
      .hero.first {
        .hero__wrapper {
          transform: none;
          margin-top: 100px;
          top: 0;
        }
      }
    }
  }

  .searchVillaMobile {
    padding: 20px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: $stoneCream;
    z-index: 1000;
    margin-top: 100vh;

    &.open {
      transition: all .4s ease;
      margin-top: 0;
    }

    .searchVillaMobileHeader {
      padding: 20px;
      border-bottom: 1px solid $yellowStone;
      background: $stoneCream;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1;

      h1 {
        font-style: normal;
        font-size: 24px;
        margin: 0;
      }

      .icon {
        cursor: pointer;

        &.close {
          background-image: url(../assets/img/src/icons/close-x.svg);
          background-size: 13px 13px;
          width: 13px;
          height: 13px;
        }
      }
    }

    .searchVillaMobileControls {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
    }

    .searchVillaInner {
      padding: 0 20px;
      margin-bottom: 20px;
      position: fixed;
      top: 76px;
      bottom: 74px;
      left: 0;
      right: 0;
      overflow: hidden scroll;
      z-index: 2;

      h3 {
        margin: 20px 0;
      }
    }
  }
  .searchVilla-toggle {
    width: 100%;
  }
</style>
